<script setup lang="tsx">
import { computed, onBeforeMount, ref } from 'vue'
import Multiselect from 'vue-multiselect'
import type { Response, Instance } from '@/models/api-generated'
import http from '@/services/http'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = defineProps<{
	class: any
	multiple?: boolean
}>()
const isLoading = ref(false)
const model = defineModel<Instance | Instance[] | undefined>({ required: true })

interface multi {
	group: string
	instances: Instance[]
}
const options = ref<Instance[] | multi[]>(props.multiple ? [{ group: t('misc.all'), instances: [] }] : [])
const groupLabel = computed(() => (props.multiple ? 'group' : undefined))
const groupValues = computed(() => (props.multiple ? 'instances' : undefined))

onBeforeMount(() => search(''))

async function search(q: string) {
	isLoading.value = true

	const { data } = await http.get<Response<Instance[]>>('api/instance/search?q=' + q)
	if (data.data) {
		if (props.multiple) (options.value[0] as multi).instances = data.data
		else options.value = data.data
	}

	isLoading.value = false
}
</script>

<template>
	<Multiselect
		:allow-empty="false"
		:class="props.class"
		:multiple="props.multiple"
		:group-select="props.multiple"
		:group-label="groupLabel"
		:group-values="groupValues"
		:show-labels="false"
		:options="options"
		:internal-search="false"
		:preserve-search="true"
		:show-no-results="false"
		:loading="isLoading"
		v-model="model"
		label="name"
		track-by="id"
		@search-change="search"
	>
	</Multiselect>
</template>
